export type Tone = "pos" | "neg" | "g" | "a" | "r" | undefined;

/** Maps the source prototype's ad-hoc `pos`/`neg`/`g`/`a`/`r` tone codes to MUI palette color tokens. */
export function toneColor(tone: Tone): string | undefined {
  switch (tone) {
    case "pos":
    case "g":
      return "success.main";
    case "neg":
    case "r":
      return "error.main";
    case "a":
      return "warning.main";
    default:
      return undefined;
  }
}

export function toneChipColor(tone: Tone): "success" | "warning" | "error" | "default" {
  switch (tone) {
    case "pos":
    case "g":
      return "success";
    case "neg":
    case "r":
      return "error";
    case "a":
      return "warning";
    default:
      return "default";
  }
}
